import TemplateView from '../../../TemplateView'
import LicenseList from './licenseList/LicenseList'
import FirstLicensePurchaseChooser from './chooser/FirstLicensePurchaseChooser'
import PurchaseCard from './PurchaseCard'
import PurchaseLightBox from './purchaseLightBox/PurchaseLightBox'
import {licensesType, purchaseCardType, purchaseStrategyType} from '../constants'
import SwitchToFreeLightBox from './switchToFreeLightBox/SwitchToFreeLightBox'
import {connect} from '../../../redux/utils'
import {getLastLicenseType, isFirstLoading, isHavePurchases} from '../selectors'
import {bindActionCreators} from 'redux'
import {setNextPurchaseStepNumber, setPurchaseStrategyType, startAddUsersProcess, startGetFreeProcess, startPurchaseProcess} from './purchaseLightBox/actions'

class LicensesPageContent extends TemplateView {
    constructor({
        setPurchaseStrategyType = () => {},
        setNextPurchaseStepNumber = () => {},
        startAddUsersProcess = () => {},
        startPurchaseProcess = () => {},
        startGetFreeProcess = () => {},
    }) {
        super()

        this.state = {
            firstLoading: false,
            havePurchases: false,
            lastLicenseType: '',
        }

        this.actions = {
            setPurchaseStrategyType,
            setNextPurchaseStepNumber,
            startAddUsersProcess,
            startPurchaseProcess,
            startGetFreeProcess,
        }

        this.onAnyStatePropertyChanged(['havePurchases', 'firstLoading'], () => {
            this.$purchaseCardPlaceholder.toggle(this.state.havePurchases && !this.state.firstLoading)
            this.firstLicensePurchaseChooser.toggle(!this.state.havePurchases && !this.state.firstLoading)
        })

        this.onStatePropertyChanged('lastLicenseType', (lastLicenseType) => {
            this.$purchaseCardPlaceholder.empty()
            new PurchaseCard({
                cardType: lastLicenseType === licensesType.FREE ? purchaseCardType.UPGRADE : purchaseCardType.RENEWAL,
                onPurchaseClick: () => {
                    this.actions.startPurchaseProcess(() => this.showPurchaseLightBox(purchaseStrategyType.PURCHASE))
                },
                onSwitchToFreeButtonClick: () => {
                    this.actions.setPurchaseStrategyType(purchaseStrategyType.FREE)
                    this.actions.setNextPurchaseStepNumber()
                    this.switchToFreeLightBox.show()
                },
            }).init(this.$purchaseCardPlaceholder)
        })
    }

    templateHtml() {
        return '<div class="content">' +
               '    <div class="pageTitle"><%=title%></div>' +
               '    <div class="licenseListPlaceholder"/>' +
               '    <div class="purchaseCardPlaceholder"/>' +
               '    <div class="chooserPlaceholder"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licensing.manage.page_title'
        }
    }

    afterRender() {
        this.$purchaseCardPlaceholder = this.find('.purchaseCardPlaceholder')

        new LicenseList({
            onPurchaseClick: () => {
                this.actions.startAddUsersProcess(() => this.showPurchaseLightBox(purchaseStrategyType.ADD_USERS))
            }
        }).init(this.find('.licenseListPlaceholder'))

        this.firstLicensePurchaseChooser = new FirstLicensePurchaseChooser({
            openPurchaseLightBox: () => this.actions.startPurchaseProcess(() => this.showPurchaseLightBox(purchaseStrategyType.FIRST_PURCHASE)),
            openGetFreeLightBox: () => this.actions.startGetFreeProcess(() => this.showPurchaseLightBox(purchaseStrategyType.FIRST_FREE)),
        }).init(this.find('.chooserPlaceholder'))

        this.purchaseLightBox = new PurchaseLightBox().init(this.getEl())
        this.switchToFreeLightBox = new SwitchToFreeLightBox().init(this.getEl())
    }

    showPurchaseLightBox(strategyType) {
        this.actions.setPurchaseStrategyType(strategyType)
        this.purchaseLightBox.show()
    }
}

export default connect(
    (state) => ({
        firstLoading: isFirstLoading(state),
        havePurchases: isHavePurchases(state),
        lastLicenseType: getLastLicenseType(state),
    }),
    (dispatch) => ({
        setPurchaseStrategyType: bindActionCreators(setPurchaseStrategyType, dispatch),
        setNextPurchaseStepNumber: bindActionCreators(setNextPurchaseStepNumber, dispatch),
        startAddUsersProcess: bindActionCreators(startAddUsersProcess, dispatch),
        startPurchaseProcess: bindActionCreators(startPurchaseProcess, dispatch),
        startGetFreeProcess: bindActionCreators(startGetFreeProcess, dispatch),
    })
)(LicensesPageContent)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/LicensesPageContent.js